"use client";

import { Building2, GraduationCap } from "lucide-react";
import { ProfileAvatar } from "../ui/profile-avatar";
import { COURSE_AVATAR } from "../course-card/people/course-people.constants";
import { courseInitials } from "../course-card/people/course-people.utils";
import type { CourseProfileProps } from "./course-profile.types";

/** Present only the provider-supplied profile facts, with a consistent portrait fallback. */
export function CourseProfile({
  name,
  imageUrl,
  role,
  affiliation,
  description,
  kind = "instructor",
}: CourseProfileProps) {
  return (
    <div className="space-y-4">
      <h3 className="break-words text-lg font-semibold leading-6 text-[#344054]">
        {name}
      </h3>
      <div className="flex items-center gap-4">
        <ProfileAvatar
          src={imageUrl}
          alt={name}
          fallback={courseInitials(name)}
          className={`h-20 w-20 text-xl ${COURSE_AVATAR.border}`}
          imageClassName={
            kind === "provider" ? "object-contain p-2" : undefined
          }
          fallbackClassName={COURSE_AVATAR.fallback}
        />
        {(role || affiliation) && (
          <div className="min-w-0 space-y-2 text-sm leading-5 text-muted-foreground">
            {role && (
              <p className="flex items-start gap-2">
                <GraduationCap
                  aria-hidden="true"
                  className="mt-0.5 h-4 w-4 shrink-0"
                />
                <span className="break-words">{role}</span>
              </p>
            )}
            {affiliation && (
              <p className="flex items-start gap-2">
                <Building2
                  aria-hidden="true"
                  className="mt-0.5 h-4 w-4 shrink-0"
                />
                <span className="break-words">{affiliation}</span>
              </p>
            )}
          </div>
        )}
      </div>
      {description && (
        <p className="whitespace-pre-line text-sm leading-6 text-muted-foreground">
          {description}
        </p>
      )}
    </div>
  );
}
